import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MerchantService } from '../../services/merchant.service';
import { PayerHeaderComponent } from '../layout/payer-header/payer-header.component';

@Component({
    selector: 'app-error-page',
    imports: [CommonModule, RouterModule, PayerHeaderComponent],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
  messageError: string;
  // Presentation-only addition: several routes already pass a `code` query
  // param when navigating here (e.g. code: '002'/'005'), but it was never
  // read before. Surfacing it is purely visual — it does not change what
  // triggers navigation to this page.
  errorCode: string;
  // Presentation-only: reads whatever merchant MerchantService already has
  // in memory (set earlier in the payer flow, e.g. by get-invoice), so a
  // payment error still shows who the payer was paying. No new request is
  // made, and this is undefined/null for errors reached outside a merchant
  // context (e.g. a plain 404), which correctly shows no merchant branding.
  currentMerchant: any;

  constructor(
    private route: ActivatedRoute,
    private merchantService: MerchantService
  ) {}

  ngOnInit() {
    this.currentMerchant = this.merchantService.getCurrentMerchant();
    this.route.queryParams.subscribe(params => {
      this.messageError = params['message'] || 'Page not found';
      this.errorCode = params['code'] || '';
    });
  }
}
